const REGION_PREFIXES = ['fr', 'nl', 'de', 'uk'];

const LOCALE_HOME_NAMES: Record<string, string> = {
  fr: 'Lemonade Assurance',
  de: 'Lemonade Versicherung',
  nl: 'Lemonade Verzekering',
  uk: 'Lemonade Insurance',
  en: 'Lemonade Insurance',
};

const formatBreadcrumbName = (slug: string): string => {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const extractNameFromTitle = (title: string): string | null => {
  const separators = /[|•·—–-]/;
  const parts = title.split(separators).map(p => p.trim());
  if (parts.length > 0 && parts[0].length > 0) {
    return parts[0];
  }
  return null;
};

export const generateBreadcrumbSchema = (
  path: string,
  baseUrl: string,
  pageTitle?: string,
  breadcrumbLabel?: string,
) => {
  const cleanPath = path.split('?')[0].split('#')[0];
  const segments = cleanPath.split('/').filter(Boolean);

  let regionPrefix = '';
  let languagePrefix = '';
  let pathSegments = segments;

  if (segments.length > 0 && REGION_PREFIXES.includes(segments[0])) {
    regionPrefix = segments[0];
    pathSegments = segments.slice(1);

    if (pathSegments.length > 0 && pathSegments[0] === 'en') {
      languagePrefix = 'en';
      pathSegments = pathSegments.slice(1);
    }
  }

  if (pathSegments.length === 0 || (pathSegments.length === 1 && pathSegments[0] === 'home')) {
    return null;
  }

  const isEnglish = languagePrefix === 'en' || !regionPrefix;
  const homeName = isEnglish ? 'Lemonade Insurance' : LOCALE_HOME_NAMES[regionPrefix] || 'Lemonade Insurance';
  const homeUrl = regionPrefix
    ? languagePrefix
      ? `${baseUrl}/${regionPrefix}/${languagePrefix}`
      : `${baseUrl}/${regionPrefix}`
    : baseUrl;

  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: homeName,
      item: homeUrl,
    },
  ];

  let currentPath = regionPrefix ? (languagePrefix ? `/${regionPrefix}/${languagePrefix}` : `/${regionPrefix}`) : '';

  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const isLastSegment = index === pathSegments.length - 1;
    const name = isLastSegment
      ? breadcrumbLabel || extractNameFromTitle(pageTitle || '') || formatBreadcrumbName(segment)
      : formatBreadcrumbName(segment);
    items.push({
      '@type': 'ListItem',
      position: index + 2,
      name,
      item: `${baseUrl}${currentPath}`,
    });
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
};
